module.exports = __webpack_public_path__ + "img/-LV1A2rxUsBRuStZJaqd.fa80ff24.jpg";